// Da Vinci Institute - UI Translations

export const translations = {
    en: {
        nav: {
            home: 'Home',
            about: 'About',
            departments: 'Departments',
            news: 'News',
            contact: 'Contact',
        },
        hero: {
            welcome: 'Welcome to Da Vinci Institute',
            subtitle: 'Better education for a more prosperous nation and a brighter life.',
            explore: 'Explore Departments',
            contact: 'Contact Us',
        },
        sections: {
            mission: 'Our Mission',
            vision: 'Our Vision',
            departments: 'Our Departments',
            latestNews: 'Latest News & Updates',
            getInTouch: 'Get in Touch',
            ourStaff: 'Our Staff',
        },
        about: {
            missionDesc: 'Developing a mature and educated generation equipped with knowledge and patriotism through enhancing teachers\' intellectual capabilities and teaching skills using modern methods. Creating a supportive educational environment to advance students\' level in all aspects. Focusing on selective activities across all fields related to the development of institute students, especially in scientific, national, environmental, sports, and health domains.',
            visionDesc: 'Better education for a more prosperous nation and a brighter life.',
            homeTitle: 'Empowering Future Generations',
            homeDesc: 'Da Vinci Institute was established in 2012 as the first private institute in the Duhok Governorate. It has played a pioneering role in higher education in the Kurdistan Region by introducing the first specialized Oil and Gas Sciences Department in the region.',
            historyText: `Da Vinci Institute was established in 2012 as the first private institute in the Duhok Governorate. It has played a pioneering role in higher education in the Kurdistan Region by introducing the first specialized Oil and Gas Sciences Department in the region.

The institute admits a new cohort of students each year who have successfully completed the ninth grade (middle school), providing them with a strong academic and practical foundation for professional and technical careers. Over the years, Da Vinci Institute has continuously expanded and enhanced its educational services through a highly qualified and carefully selected teaching staff holding advanced academic degrees.

To support quality education, the institute has established modern scientific laboratories and has organized hundreds of academic and scientific activities across its various departments. Since its establishment, the institute has proudly graduated nine batches of students.

Currently, Da Vinci Institute offers academic programs through the following four departments:
• Department of Computer Science
• Department of Oil and Gas Sciences
• Department of Management
• Department of Accounting`,
        },
        common: {
            learnMore: 'Learn More',
            readMore: 'Read More',
            viewAll: 'View All',
            viewDetails: 'View Details',
            send: 'Send Message',
        },
        contact: {
            address: 'Kurdistan, Vawjer Street, Masike 1 Qr. 42001, Duhok',
            phone: 'Phone',
            email: 'Email',
            name: 'Name',
            subject: 'Subject',
            message: 'Message',
        }
    },
    ar: {
        nav: {
            home: 'الرئيسية',
            about: 'من نحن',
            departments: 'الأقسام',
            news: 'الأخبار',
            contact: 'اتصل بنا',
        },
        hero: {
            welcome: 'مرحباً بكم في معهد دا فينشي',
            subtitle: 'تعليم أفضل من أجل أمة أكثر ازدهاراً وحياة أكثر إشراقاً.',
            explore: 'استكشف الأقسام',
            contact: 'اتصل بنا',
        },
        sections: {
            mission: 'رسالتنا',
            vision: 'رؤيتنا',
            departments: 'أقسامنا',
            latestNews: 'آخر الأخبار والتحديثات',
            getInTouch: 'تواصل معنا',
            ourStaff: 'كادرنا',
        },
        about: {
            missionDesc: 'إعداد جيل واعٍ ومتعلم، متسلح بالمعرفة والروح الوطنية، من خلال تعزيز القدرات الفكرية ومهارات التدريس لدى المعلمين باستخدام الأساليب الحديثة. خلق بيئة تعليمية داعمة للارتقاء بمستوى الطلبة في كافة الجوانب. التركيز على أنشطة مختارة في جميع المجالات المتعلقة بتطوير طلبة المعهد، لا سيما في المجالات العلمية، الوطنية، البيئية، الرياضية، والصحية.',
            visionDesc: 'تعليمٌ أفضل من أجل أمة أكثر ازدهاراً وحياة أكثر إشراقاً.',
            homeTitle: 'تمكين أجيال المستقبل',
            homeDesc: 'تأسس معهد دافنشي في عام ٢٠١٢ كأول معهد تقني خاص في محافظة دهوك. وقد لعب المعهد دوراً ريادياً في قطاع التعليم العالي في إقليم كوردستان من خلال استحداث أول قسم تخصصي لعلوم النفط والغاز على مستوى المنطقة.',
            historyText: `تأسس معهد دافنشي في عام ٢٠١٢ كأول معهد تقني خاص في محافظة دهوك. وقد لعب المعهد دوراً ريادياً في قطاع التعليم العالي في إقليم كوردستان من خلال استحداث أول قسم تخصصي لعلوم النفط والغاز على مستوى المنطقة.

يستقبل المعهد سنوياً دفعة جديدة من الطلبة الذين أتموا مرحلة الصف التاسع بنجاح، حيث يعمل على تزويدهم بقاعدة أكاديمية وعملية رصينة تؤهلهم للمسارات المهنية والتقنية. وعلى مر السنين، واصل معهد دافنشي توسيع وتطوير خدماته التعليمية عبر استقطاب نخبة من الكوادر التدريسية المؤهلة من حملة الشهادات العليا.

ودعماً لجودة التعليم، قام المعهد بإنشاء مختبرات علمية حديثة وتنظيم المئات من الأنشطة الأكاديمية والعلمية في مختلف أقسامه. ومنذ تأسيسه، يفتخر المعهد بتخريج ثمان دورات من الطلبة المؤهلين لسوق العمل.

يقدم معهد دافنشي حالياً برامجه الأكاديمية من خلال الأقسام الأربعة التالية:
• قسم علوم الحاسبات
• قسم علوم النفط والغاز
• قسم الإدارة
• قسم المحاسبة`,
        },
        common: {
            learnMore: 'تعرف على المزيد',
            readMore: 'اقرأ أكثر',
            viewAll: 'عرض الكل',
            viewDetails: 'عرض التفاصيل',
            send: 'إرسال الرسالة',
        },
        contact: {
            address: 'كوردستان، شارع ڤاوژير، حي ماسيك ١، ٤٢٠٠١، دهوك',
            phone: 'الهاتف',
            email: 'البريد الإلكتروني',
            name: 'الاسم',
            subject: 'الموضوع',
            message: 'الرسالة',
        }
    },
    ku: {
        nav: {
            home: 'سەرەکی',
            about: 'دەربارە',
            departments: 'پشکەکان',
            news: 'نووچە',
            contact: 'پەیوەندی',
        },
        hero: {
            welcome: 'بۆ پەیمانگەها داڤنشی ب خێرهاتی',
            subtitle: 'فێربوونەکا باشتر بۆ وەلاتەکێ ئاڤەدانتر و ژیانەکا گەشتر.',
            explore: 'پشکەکان ببینە',
            contact: 'پەیوەندی بکە',
        },
        sections: {
            mission: 'پەیاما مە',
            vision: 'دیتنا مە',
            departments: 'پشکێن مە',
            latestNews: 'دوایین نووچە و پێشهاتەکان',
            getInTouch: 'دگەل مە ب ئاخڤە',
            ourStaff: 'کادرێ مە',
        },
        about: {
            missionDesc: 'پێگەهاندنا نفشەکێ پێگەهشتی، پەروەردەکری ب زانست و نیشتیمانپەروەریێ ب رێیا گەشەکرنا هزر و شیانێن فێرکرنێ یێن ماموستایان ب رێکێن سەردەمیانە. دروستکرنا ژینگەهەکا پەروەردەییا هاریکار بۆ پێشڤەبرنا ئاستێ قوتابییان ژ هەمی لایەکی. پویتەدان ب چالاکیێن بژارە و ل سەر هەمی بیاڤێن گرێدای پێشڤەبرنا قوتابیێن پەیمانگەهێ نەخاسمە یێن زانستی، نەتەوەیی، ژینگەهـ پارێزی، وەرزشی و تەندروستی.',
            visionDesc: 'فێربوونەکا باشتر بۆ وەلاتەکێ ئاڤەدانتر و ژیانەکا گەشتر.',
            homeTitle: 'بۆ هێزکرنا نه‌وه‌یێن پاشه‌رۆژێ',
            homeDesc: 'پەیمانگەها داڤنشی ل سالا ٢٠١٢  وەک ئێکەم پەیمانگەها تایبەت ل پارێزگەها دهۆکێ هاتە دامەزراندن. پەیمانگەهێ رۆلەکێ پێشەنگ هەبوویە د بوارێ خواندنا بلند دا ل هەرێما کوردستانێ، ئەو ژی ب رێکا ڤەکرنا ئێکەم بەشێ پسپۆر یێ زانستێن نەفت و گازێ ل سەر ئاستێ هەرێمێ.',
            historyText: `پەیمانگەها داڤنشی ل سالا ٢٠١٢  وەک ئێکەم پەیمانگەها تایبەت ل پارێزگەها دهۆکێ هاتە دامەزراندن. پەیمانگەهێ رۆلەکێ پێشەنگ هەبوویە د بوارێ خواندنا بلند دا ل هەرێما کوردستانێ، ئەو ژی ب رێکا ڤەکرنا ئێکەم بەشێ پسپۆر یێ زانستێن نەفت و گازێ ل سەر ئاستێ هەرێمێ.

پەیمانگەهـ سالانە پێشوازیێ ل کۆمەکا نوی یا قوتابیێن دەرچوویێن پۆلا نەهێ (ناڤنجی) دکەت، و بنەمایەکێ زانستی و پراکتیکی یێ بێهێز بۆ وان دابین دکەت دا کو بشێن د پاشەرۆژێ دا د بوارێن تەکنیکی و پیشەیی دا سەرکەفتنێ بینن. ل سەر دەمێ چەندین سالان، پەیمانگەها داڤنشی بەردەوام کار ل سەر گەشەپێدان و باشترکرنا خزمەتگۆزاریێن خۆ یێن پەروەردەیی کرییە، ئەو ژی ب رێکا ستافەکێ مامۆستایێن خودان شیان و خودان بروانامەیێن بلند یێن زانستی.

پێخەمەت پشتەڤانیکردنا کواڵیتیا خواندنێ، پەیمانگەهێ چەندین تاقیگەهێن زانستی یێن سەردەم دامەزراندینە و ب سەدان چالاکییێن ئەکادیمی و زانستی د بەشێن خۆ یێن جودا جودا دا ئەنجام داینە. ژ دەما دامەزراندنێ و هەتا نوکە، پەیمانگەهـ شانازیێ ب نەهـ گەرێن دەرچوونا قوتابیان دکەت.

ل دەمێ نوکە، پەیمانگەها داڤنشی ب رێکا ڤان چار بەشێن ل خوارێ بەرنامەیێن خۆ یێن ئەکادیمی پێشکێش دکەت:
• بەشێ زانستێن کۆمپیوتەری
• بەشێ زانستێن نەفت و گازێ
• بەشێ کارگێری
• بەشێ ژمێریاری`,
        },
        common: {
            learnMore: 'پتر بزانە',
            readMore: 'پتر بخوینە',
            viewAll: 'هەمی ببینە',
            viewDetails: 'بینینا پتر',
            send: 'نامەیێ بنێرە',
        },
        contact: {
            address: 'كوردستان، جادەیا ڤاوژێر، تاخێ ماسيكێ ١، ٤٢٠٠١، دهۆك',
            phone: 'تەلەفۆن',
            email: 'ئیمەیل',
            name: 'ناڤ',
            subject: 'بابەت',
            message: 'نامە',
        }
    }
};
